import AirDatepicker from "air-datepicker";
import "air-datepicker/air-datepicker.css";
const calendar = document.querySelector(".calendar-wrapper");

class BookingForm {
  constructor() {
    this.selectors();

    // global attr

    this.activityDetail = {};
    this.isKecakButton = false;
  }

  selectors() {
    this.calendarWrapper = document.querySelector(".transport-booking-form");
    if (this.calendarWrapper) {
      this.inputs = this.calendarWrapper.querySelectorAll("input");
      this.init();
    }
  }

  init() {
    this.formData = window?.bookingDetail || {};
    this.calendarAction();
  }

  bookingKecak() {
    this.calendarWrapper = document.querySelector(".transport-booking-form");
    this.inputs = this.calendarWrapper.querySelectorAll("input");
    this.activityDetail.price = "IDR 150K";
    this.activityDetail.pax = 1;
  }

  textToNumber = () => {
    const pax = this.calendarWrapper.querySelector('input[name="Pax"]');

    if (!pax) return;

    pax.addEventListener("input", () => {
      pax.value = pax.value.replace(/[^0-9]/g, "");
      const inputPax = parseInt(pax.value);
      if (
        this.activityDetail.pax &&
        parseInt(this.activityDetail.pax) > 1 &&
        inputPax < parseInt(this.activityDetail.pax)
      ) {
        this.formData.pax = parseInt(this.activityDetail.pax);
        pax.value = parseInt(this.activityDetail.pax);
      } else {
        this.formData.pax = parseInt(pax.value);
      }
    });
  };

  createTotal = () => {
    const total = this.activeForm.querySelector("form .total");
    const originalPrice =
      convertIDRtoNumber(this.formData?.price) * this.formData?.pax;

    if (total) {
      total.innerHTML = `<div class="cart-item"> ${formatIDR(
        convertIDRtoNumber(this.formData?.price)
      )} x ${this.formData?.pax} pax</div>`;
      total.innerHTML += `<div class="sub-total">Total : ${formatIDR(
        originalPrice
      )}</div>`;
    }
  };

  formChecker = () => {
    let isValid = true;
    if (this.inputs) {
      this.inputs.forEach((input) => {
        const val = input.value;
        const name = input.name;
        const isRequire = input.classList.contains("require");
        this.formData[name] = val || "-";
        if (isRequire && !val.trim()) {
          input.classList.add("red");
          isValid = false;
        } else {
          input.classList.remove("red");
        }
      });
    }

    return isValid;
  };

  calendarAction() {
    const buttonSend = this.calendarWrapper.querySelectorAll(".button-send");

    if (buttonSend) {
      buttonSend.forEach((button) => {
        button.addEventListener("click", async () => {
          const isPayNowButton = button.dataset.payment;
          button.classList.add("disabled");
          button.innerHTML = "Submiting...!";
          await this.sendDetail(isPayNowButton);
          button.innerHTML = "Submit";
          button.classList.remove("disabled");
        });
      });
    }
  }

  createFormData() {
    // Button booking inside component block

    this.formData.title = this.activityDetail?.title;
    this.formData.price = convertIDRtoNumber(this.activityDetail?.price);
    this.formData.pax = this.activityDetail?.pax;

    // Set activity name
    let title = `${this.formData.title} | ${formatIDR(this.formData.price)} `;

    if (this.activityDetail?.is_package) {
      title = `Package: ${title}`;
    }

    if (this.activityDetail?.title)
      this.calendarWrapper.querySelector('input[name="Activity"]').value =
        title;
  }

  getFomrData() {
    if (this.inputs) {
      this.inputs.forEach((input) => {
        const val = input.value;
        const name = input.name;
        this.formData[name] = val;
      });
    }
  }

  async createSnap() {
    let form = new FormData();
    form.append("action", "create_midtrans");
    form.append("order_id", "ORDER-" + Date.now());
    form.append("gross_amount", 1);

    const req = await fetch(ajaxurl, {
      method: "POST",
      body: form,
    });

    const data = await req.json();
    console.log("data", data);
    snap.pay(data.data.token);
  }

  async sendDetail(payNow) {
    // Continue if passed
    if (!this.formChecker()) return;

    this.getFomrData();

    let message = `%0A*Booking Detail:*%0A`;

    const formData = {};

    for (const [key, value] of Object.entries(this.formData)) {
      const id = key.toLowerCase();
      formData[id] = value;

      if (value) {
        if (
          id !== "booking_type" &&
          id !== "title" &&
          id !== "price" &&
          id !== "booking_type"
        ) {
          message += `${key}: ${value}%0A`;
        }
      }
    }

    if (this.formData?.price) {
      formData["price_raw"] = this.formData?.price;
    }

    if (this.formData?.pax) {
      const originalPrice = this.formData?.price * this.formData?.pax;
      message += `*Total: ${formatIDR(originalPrice)}*%0A`;
    }

    if (payNow) this.createSnap();

    // const response = await fetch(ajaxurl, {
    //   method: "POST",
    //   headers: { "Content-Type": "application/x-www-form-urlencoded" },
    //   body: new URLSearchParams({
    //     action: "save_booking",
    //     data: new URLSearchParams(formData).toString(),
    //   }),
    // });

    // const { data } = await response.json();

    // window.open(
    //   `https://api.whatsapp.com/send?phone=6287720936827&text=Booking ID : *${data.id}*%0A ${message}`
    // );

    window.lenis.start();
    this.calendarWrapper.classList.remove("active");

    const successMessage = document.querySelector(".thank-you-message");

    if (successMessage) {
      const buttonCloseMessage = successMessage.querySelector(
        ".button-close .underline-button"
      );
      successMessage.classList.add("active");

      buttonCloseMessage.addEventListener("click", () => {
        successMessage.classList.remove("active");

        this.activeFormType = 1;
        this.activeForm = null;
      });
    }
  }
}

const formatIDR = (number) => {
  return new Intl.NumberFormat("id-ID", {
    style: "currency",
    currency: "IDR",
    minimumFractionDigits: 0,
  }).format(number);
};

const convertIDRtoNumber = (text) => {
  if (!text) return;

  const match = text.match(/(\d+(?:\.\d+)?)([KkMm]?)/);
  if (!match) return 0;

  let [_, num, suffix] = match;
  let value = parseFloat(num);

  switch (suffix.toUpperCase()) {
    case "K":
      value *= 1000;
      break;
    case "M":
      value *= 1000000;
      break;
  }

  return value;
};

document.addEventListener("DOMContentLoaded", () => {
  const calendars = document.querySelectorAll(".calendar");

  if (calendars) {
    calendars.forEach((calendar) => {
      const dateInput =
        calendar.parentElement.querySelector('input[name="Date"]');
      new AirDatepicker(calendar, {
        inline: true,
        locale: {
          days: [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday",
          ],
          daysShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
          daysMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
          months: [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December",
          ],
          monthsShort: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec",
          ],
          today: "Today",
          clear: "Clear",
          dateFormat: "MM/dd/yyyy",
          timeFormat: "hh:ii aa",
          firstDay: 0,
        },
        minDate: new Date(),
        onSelect: ({ date, formattedDate }) => {
          const pickupDateInput = document.getElementById("pickup-date");

          if (pickupDateInput) {
            pickupDateInput.value = formattedDate;
          }
        },
      });
    });
  }

  new BookingForm();
});
